import React from 'react';
import DataTable from "@inspinia-react/data-table";
import { api, get, getBranchOwner } from '@config'

import { Modal } from 'react-bootstrap';

import TemplateICMS from './index';
import SelectIcms from './select'
import { checkIfBranchExists } from '../../../../../utils';
class ICMSList extends React.Component {
    constructor(props) {
        checkIfBranchExists()
        super(props)
        this.state = { list: [] }
        this.branch = getBranchOwner().id

        this.onEdit = this.onEdit.bind(this)
    }

    componentDidMount() {
        setTimeout(() => this.getICMSList(), 300);
    }

    getICMSList() {
        const payload = resp => {
            this.setState({ ...this, list: resp.reverse() })
        }
        get(`${api.icms}?branch_owner=${this.branch}`, payload)
    }

    onEdit() {
        setTimeout(() => { window.location.reload() }, 2000)
    }

    render() {
        return <div className="div">
            <h1 className='text-center' >ICMS</h1>
            <div className="text-center">
                <TemplateICMS create onSuccess={this.onEdit} />
            </div>
            <DataTable
                columns={[
                    {
                        name: "Nome",
                        selector: "name"
                    },
                    {
                        name: "Origem",
                        cell: data => {
                            switch (data.orig) {
                                case 0:
                                    return "Nacional"
                                case 1:
                                    return "Estrangeira"
                                default:
                                    return "Insponivel"
                            }
                        }
                    },
                    {
                        name: "CSOSN",
                        selector: "csosn"
                    },
                    {
                        name: "Ações",
                        center: true,
                        cell: data => {
                            return <TemplateICMS icms={data} onSuccess={this.onEdit} />
                        }
                    }
                ]}
                noHeader
                data={this.state.list}
            />
        </div>
    }
}

export function ModalIcms(props) {
    const [showModal, setShowModal] = React.useState(false)
    return <div>

        <button className='fas fa-edit btn btn-primary btn-sm' onClick={() => setShowModal(true)}></button>
        <Modal show={showModal} onHide={() => setShowModal(false)}>
            <Modal.Body>
                <SelectIcms onSuccess={props.onSuccess} onChangeIcms={props.onChangeIcms} />
            </Modal.Body>
            <Modal.Footer>
                <button className='dim btn btn-danger' onClick={() => setShowModal(false)}>Voltar</button>
            </Modal.Footer>
        </Modal>
    </div>
}

export default ICMSList;


// WEBPACK FOOTER //
// ./src/components/pages/fiscal/taxes/template-icms/list.jsx